import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
// ts-ignore
import authReducer from '../slices/authSlice.ts';
import jobsReducer from '../slices/jobSlice.ts';
import { userProfileReducer } from '../slices/userProfileSlice.ts';
import ratingReducer from '../slices/ratingSlice.ts';
import { chatsReducer } from '../slices/chatSlice.ts';
import bidsReducer from '../slices/bidsSlice.ts';
import likesReducer from '../slices/likesSlice.ts';
import paymentReducer from '../slices/paymentSlice.ts';
import favouriteReducer from '../slices/favouriteSlice.ts';

const rootReducer = combineReducers({
  auth: authReducer,
  bids: bidsReducer,
  likes: likesReducer,
  jobs: jobsReducer,
  rating: ratingReducer,
  chatsState: chatsReducer,
  profile: userProfileReducer,
  payment: paymentReducer,
  favourite: favouriteReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

// Define RootState as the type of the entire state tree
export type RootState = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
